import { CallTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { CallType } from '@/services/graphql/types';

export const mapperToCallTypeDataEnum = createEnumMapperFunction(
  CallType,
  CallTypeDataEnum
);
